body_width = jQuery('body').width();

/* sticky-nav */
jQuery(function () {

	if(body_width > 991){

		jQuery(window).scroll(function () {
			animate_elems();
		});

		function animate_elems() {
			wintop = jQuery(window).scrollTop();

			if (wintop > 150) {
				jQuery('.navbar-top').addClass('animated');
			} else {
				jQuery('.navbar-top').removeClass('animated');
			}
			if (wintop > 200) {
				jQuery('.navbar-top').addClass('animated-initial');
			} else {
				jQuery('.navbar-top').removeClass('animated-initial');
			}
			if (wintop > 250) {
				jQuery('.navbar-top').addClass('animated-passed');
			} else {
				jQuery('.navbar-top').removeClass('animated-passed');
			}
		}
	}
});




/*menu*/
jQuery(function () {
	jQuery('.navbar-nav').find('.sub-menu').each(function () {
		jQuery('<span class="arrowdown"><svg style="fill: currentColor;" class="icon" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"  viewBox="0 0 129 129" >			<path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"/>		</symbol></svg></span>').insertBefore(this);
	});
	jQuery('.arrowdown').click(function () {
		if (jQuery(this).hasClass('close-arrow')) {
			jQuery(this).removeClass('close-arrow');
			jQuery(this).closest('li').find('.sub-menu').first().removeClass('open-mobile');
		} else {
			jQuery(this).addClass('close-arrow');
			jQuery(this).closest('li').find('.sub-menu').first().addClass('open-mobile');
		}
	});
});
/*Amination  manubger*/
jQuery(function () {
	jQuery('.nav-icon').click(function () {
		jQuery(this).toggleClass('open');
		jQuery('.nav-menu').toggleClass('open');
	});
});
/* vid popup */
var active = false;
jQuery(document).ready(function () {
	jQuery('.play-video').click(function () {
		if (!active) {
			var vid_type = jQuery(this).attr('data-vid_type');
			var vid_frame = jQuery(this).attr('data-vid');

			if (vid_type=='iframe') {
				if (vid_frame) {
					jQuery('body').append('<div class="vid-popup"><div class="close-popup" onclick="closepopup()">✕</div><iframe src="' + vid_frame + '?rel=0&autoPlay=1;"></div>');
					jQuery('.vid-popup').hide().show('slow');
					active = true;
				}
			}
			if (vid_type=='video') {
				if (vid_frame) {
					jQuery('body').append('<div class="vid-popup-wrap"><div class="vid-popup"><div class="close-popup" onclick="closepopup()"><svg style="fill: currentColor;" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="https://www.w3.org/2000/svg"><path d="M6.22566 4.81096C5.83514 4.42044 5.20197 4.42044 4.81145 4.81096C4.42092 5.20148 4.42092 5.83465 4.81145 6.22517L10.5862 11.9999L4.81151 17.7746C4.42098 18.1651 4.42098 18.7983 4.81151 19.1888C5.20203 19.5793 5.8352 19.5793 6.22572 19.1888L12.0004 13.4141L17.7751 19.1888C18.1656 19.5793 18.7988 19.5793 19.1893 19.1888C19.5798 18.7983 19.5798 18.1651 19.1893 17.7746L13.4146 11.9999L19.1893 6.22517C19.5799 5.83465 19.5799 5.20148 19.1893 4.81096C18.7988 4.42044 18.1657 4.42044 17.7751 4.81096L12.0004 10.5857L6.22566 4.81096Z" ></svg></div><video class="banner-video" id="desc_video" controls playsinline="true" disablePictureInPicture="true" autoplay="" loop="" muted="" poster=""><source type="video/mp4" src="' + vid_frame + '"></video></div></div>');
					jQuery('.vid-popup-wrap').hide().show();
					active = true;
				}
			}
		}
	});
});

window.closepopup = function () {
	jQuery('.vid-popup').hide('slow', function () {
		jQuery('.vid-popup').remove();
	});
	active = false;
}

/* background-image */
jQuery(function () {
	jQuery('.background-image').each(function () {
		if(jQuery(this).find('img').attr('src')){
			image_src = jQuery(this).find('img').attr('src');
		}
		if(jQuery(this).find('img').attr('data-src')){
			image_src = jQuery(this).find('img').attr('data-src');
		}
		jQuery(this).attr('style','background-image: url('+image_src+');');
	});
});

/* share button */
jQuery(function () {
	jQuery('.icon-sharing').click(function () {
		jQuery(this).closest('.social-button').find('.icon-sharing-links').toggleClass('active');
	});
});

/* slick slider */
jQuery(function () {

	var rtl_flag;
	//rtl: rtl_flag,
	if (document.dir == "rtl"){
		rtl_flag = true;
	}else{
		rtl_flag = false;
	}

	/*
	jQuery('.slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><svg class="icon" style="fill: currentColor;"  viewBox="0 0 512.005 512.005" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g><path d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005,L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251,l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"/></g></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg class="icon" style="fill: currentColor;"  viewBox="0 0 512.005 512.005" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g transform="matrix(-1 0 0 1 512.005 0)"><path d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005,L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251,l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"/></g></svg></button>',
		responsive: [{
			breakpoint: 767,
			settings: {
				slidesToShow: 2
			}
		}, {
				breakpoint: 480,
			settings: {
				slidesToShow: 1
			}
		}]
	});
	*/
	jQuery('.slider-dots').slick({
		rtl: rtl_flag,
		lazyLoad: 'ondemand',
		dots: true,
		speed: 1500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000
	});

	jQuery('.home-section-four .slider').slick({
		rtl: rtl_flag,
		lazyLoad: 'ondemand',
		speed: 1500,
		slidesToShow: 1,
		slidesToScroll: 1,
		// autoplay: true,
		// autoplaySpeed: 2000,
		prevArrow: '<button type="button" class="slick-prev"><svg class="icon" style="fill: currentColor;"  xmlns="https://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">  <g id="Group_169053" data-name="Group 169053" transform="translate(-1725 -1736)">    <g id="Ellipse_11" data-name="Ellipse 11" transform="translate(1725 1736)" fill="none" stroke="#fff" stroke-width="2">      <circle cx="26" cy="26" r="26" stroke="none"/>      <circle cx="26" cy="26" r="25" fill="none"/>    </g>    <g id="WKND-icon" transform="translate(1741 1752)">      <rect id="background" width="20" height="20" fill="none"/>      <g id="Dribbble-Light-Preview">        <g id="icons">          <path id="arrow_left-_350_" data-name="arrow_left-[#350]" d="M94,6499l-1.435-1.393,7.607-7.607H84v-2h16.172l-7.586-7.586L94,6479l10,10-10,10" transform="translate(-84 -6479)" fill="#fff" fill-rule="evenodd"/>        </g>      </g>    </g>  </g></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg class="icon" style="fill: currentColor;"  xmlns="https://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">  <g id="arrow" transform="translate(52 52) rotate(180)">    <g id="Group_169053" data-name="Group 169053" transform="translate(-1725 -1736)">      <g id="Ellipse_11" data-name="Ellipse 11" transform="translate(1725 1736)" fill="none" stroke="#fff" stroke-width="2">        <circle cx="26" cy="26" r="26" stroke="none"/>        <circle cx="26" cy="26" r="25" fill="none"/>      </g>      <g id="WKND-icon" transform="translate(1741 1752)">        <rect id="background" width="20" height="20" fill="none"/>        <g id="Dribbble-Light-Preview">          <g id="icons">            <path id="arrow_left-_350_" data-name="arrow_left-[#350]" d="M94,6499l-1.435-1.393,7.607-7.607H84v-2h16.172l-7.586-7.586L94,6479l10,10-10,10" transform="translate(-84 -6479)" fill="#fff" fill-rule="evenodd"/>          </g>        </g>      </g>    </g>  </g></svg></button>',
	});
	jQuery('.home-section-five .slider').slick({
		rtl: rtl_flag,
		lazyLoad: 'ondemand',
		speed: 1500,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [{
			breakpoint: 991,
			settings: {
				slidesToShow: 3,
				centerMode: true,
				centerPadding: '120px',
			}
		}, {
			breakpoint: 767,
			settings: {
				slidesToShow: 2,
				centerMode: true,
				centerPadding: '100px',
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '80px',
			}
		}]
	});

	jQuery('.slider-blog-populr').slick({
		speed: 1500,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		autoplay: false,
		autoplaySpeed: 2000,
		responsive: [{
			breakpoint: 991,
			settings: {
				slidesToShow: 2,
				centerMode: true,
				centerPadding: '120px',
			}
		}, {
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '100px',
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '80px',
			}
		}]
	});

	jQuery('.career-slider-wrapper').slick({
		speed: 1500,
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 2000,
		centerMode: true,
		centerPadding: '120px',
		variableWidth: true,
		prevArrow: '<button type="button" class="slick-prev"><svg id="arrow" xmlns="https://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52"><g id="Group_169053" data-name="Group 169053" transform="translate(-1725 -1736)"><g id="Ellipse_11" data-name="Ellipse 11" transform="translate(1725 1736)" fill="none" stroke="#0f172a" stroke-width="2"><circle cx="26" cy="26" r="26" stroke="none"/><circle cx="26" cy="26" r="25" fill="none"/></g><g id="WKND-icon" transform="translate(1741 1752)"><rect id="background" width="20" height="20" fill="none"/><g id="Dribbble-Light-Preview"><g id="icons"><path id="arrow_left-_350_" data-name="arrow_left-[#350]" d="M94,6499l-1.435-1.393,7.607-7.607H84v-2h16.172l-7.586-7.586L94,6479l10,10-10,10" transform="translate(-84 -6479)" fill="#0f172a" fill-rule="evenodd"/></g></g></g></g></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg xmlns="https://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52"><g id="arrow" transform="translate(52 52) rotate(180)"><g id="Group_169053" data-name="Group 169053" transform="translate(-1725 -1736)"><g id="Ellipse_11" data-name="Ellipse 11" transform="translate(1725 1736)" fill="none" stroke="#0f172a" stroke-width="2"><circle cx="26" cy="26" r="26" stroke="none"/><circle cx="26" cy="26" r="25" fill="none"/></g><g id="WKND-icon" transform="translate(1741 1752)"><rect id="background" width="20" height="20" fill="none"/><g id="Dribbble-Light-Preview"><g id="icons"><path id="arrow_left-_350_" data-name="arrow_left-[#350]" d="M94,6499l-1.435-1.393,7.607-7.607H84v-2h16.172l-7.586-7.586L94,6479l10,10-10,10" transform="translate(-84 -6479)" fill="#0f172a" fill-rule="evenodd"/></g></g></g></g></g></svg></button>',
		responsive: [{
			breakpoint: 991,
			settings: {
				slidesToShow: 2,
				centerMode: true,
				centerPadding: '120px',
			}
		}, {
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '100px',
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '80px',
			}
		}]
	});

	jQuery('.defaltpage-top-slider').slick({
		rtl: rtl_flag,
		lazyLoad: 'ondemand',
		speed: 1500,
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 2000,
		prevArrow: '<button type="button" class="slick-prev"><svg id="arrow" xmlns="https://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52"><g id="Group_169053" data-name="Group 169053" transform="translate(-1725 -1736)"><g id="Ellipse_11" data-name="Ellipse 11" transform="translate(1725 1736)" fill="none" stroke="#0f172a" stroke-width="2"><circle cx="26" cy="26" r="26" stroke="none"/><circle cx="26" cy="26" r="25" fill="none"/></g><g id="WKND-icon" transform="translate(1741 1752)"><rect id="background" width="20" height="20" fill="none"/><g id="Dribbble-Light-Preview"><g id="icons"><path id="arrow_left-_350_" data-name="arrow_left-[#350]" d="M94,6499l-1.435-1.393,7.607-7.607H84v-2h16.172l-7.586-7.586L94,6479l10,10-10,10" transform="translate(-84 -6479)" fill="#0f172a" fill-rule="evenodd"/></g></g></g></g></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg id="arrow" xmlns="https://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52"><g id="Group_169053" data-name="Group 169053" transform="translate(-1725 -1736)"><g id="Ellipse_11" data-name="Ellipse 11" transform="translate(1725 1736)" fill="none" stroke="#0f172a" stroke-width="2"><circle cx="26" cy="26" r="26" stroke="none"/><circle cx="26" cy="26" r="25" fill="none"/></g><g id="WKND-icon" transform="translate(1741 1752)"><rect id="background" width="20" height="20" fill="none"/><g id="Dribbble-Light-Preview"><g id="icons"><path id="arrow_left-_350_" data-name="arrow_left-[#350]" d="M94,6499l-1.435-1.393,7.607-7.607H84v-2h16.172l-7.586-7.586L94,6479l10,10-10,10" transform="translate(-84 -6479)" fill="#0f172a" fill-rule="evenodd"/></g></g></g></g></svg></button>',
		responsive: [{
			breakpoint: 991,
			settings: {
				slidesToShow: 2,
				centerPadding: '120px',
			}
		}, {
			breakpoint: 767,
			settings: {
				centerMode: true,
				slidesToShow: 1,
				centerPadding: '40px',
			}
		}]
	});

});


/* animation */
jQuery(function() {
	var $elems = jQuery('.ani');
	var winheight = jQuery(window).height();
	var fullheight = jQuery(document).height();

	animate_elems_initial();

	jQuery(window).scroll(function(){
		animate_elems_box();
	});

	function animate_elems_box() {
		wintop = jQuery(window).scrollTop(); // calculate distance from top of window

		// loop through each item to check when it animates
		$elems.each(function(){
			$elm = jQuery(this);

			if($elm.hasClass('active')) { return true; } // if already animated skip to the next item

			topcoords = $elm.offset().top; // element's distance from top of page in pixels

			if(windowWidth767()){
				//desktop
				if(wintop > (topcoords - (winheight*.75))) {
					// animate when top of the window is 3/4 above the element
					$elm.addClass('active');
				} else {
					// $elm.removeClass('active');
				}
			}else{
				//mobile
				if(wintop > (topcoords - (winheight*.8))) {
					// animate when top of the window is 3/4 above the element
					$elm.addClass('active');
				} else {
					// $elm.removeClass('active');
				}
			}

		});
	}


	function animate_elems_initial() {
		wintop = jQuery(window).height(); // calculate distance from top of window

		// loop through each item to check when it animates
		$elems.each(function(){
			$elm = jQuery(this);

			if($elm.hasClass('active')) { return true; } // if already animated skip to the next item

			topcoords = $elm.offset().top; // element's distance from top of page in pixels


			if(winheight > topcoords ) {
				// animate when top of the window is 3/4 above the element
				$elm.addClass('active');
			}

		});
	}
});

//Check width of window 767px
function windowWidth767(){
	if ( jQuery( window ).width() > 767 )
		return true;
	else
		return false
}


// Resources
jQuery(function(){
	var body_width = jQuery('body').width();
	/* jQuery('#more_posts').click(function(e){
		e.preventDefault();
		jQuery(this).hide();
		jQuery('.single-post-blogs').show();
	}); */

	if(body_width < 991){
		jQuery('.navbar-blog ul.blog-nav li.current-menu-item a').removeAttr('href');
		if (jQuery(".menu-industries-menu-container")[0]){
		} else {
			jQuery('.navbar-blog ul.blog-nav li.current-menu-item a').click(function(){
				jQuery('.navbar-blog').toggleClass('active');
			});
		}
	}
});

jQuery(".select-positions-catergory").change(function () {
	jQuery(this).val();
	console.log('change');
	console.log(jQuery(this).val());
	slug = jQuery(this).val();
	num = 0;
	jQuery('.positions-warp-list .box').each(function(){
		data_slug = '';
		data_slug = jQuery(this).attr('data-slug');
		if(slug=='all'){
			jQuery(this).show();
			num++;
		}else if(data_slug==slug){
			jQuery(this).show();
			num++;
		}else{
			jQuery(this).hide();
}		jQuery('#found_posts').html(num);
	});
});
jQuery( document ).ready(function() {
	jQuery('.career-accordion').click(function(){
		jQuery(this).toggleClass('open');
		jQuery(this).find('.content').toggleClass('active');
		// jQuery(this).find('.content').toggleClass('active').slideUp();
	});
});